export default "__VITE_ASSET__316f2cb4__"